import React from 'react';
import { cn } from '../../utils/cn';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'highlight';
}
export function Card({
  className,
  variant = 'default',
  children,
  ...props
}: CardProps) {
  return <div className={cn('rounded-2xl p-6 md:p-8', variant === 'default' && 'bg-white shadow-sm border border-stone-100', variant === 'highlight' && 'bg-emerald-50 border border-emerald-100', className)} {...props} data-id="element-239">
      {children}
    </div>;
}